// client/src/services/salaryService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

const getSalaries = async () => {
  const response = await fetch(`${apiUrl}/salaries`, { headers: authHeaders() });
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement des salaires.');
  return await response.json();
};

const upsertSalary = async (month, amount) => {
  const response = await fetch(`${apiUrl}/salaries/${month}`, {
    method: 'PUT',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ amount })
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Erreur lors de la sauvegarde du salaire.');
  return result;
};

const deleteSalary = async (month) => {
  const response = await fetch(`${apiUrl}/salaries/${month}`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  checkUnauthorized(response);
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    throw new Error(result.message || 'Erreur lors de la suppression du salaire.');
  }
  return true;
};

const salaryService = {
  getSalaries,
  upsertSalary,
  deleteSalary
};

export default salaryService;
